import { render, staticRenderFns } from "./text-page.vue?vue&type=template&id=744a91a6&scoped=true&"
import script from "./text-page.vue?vue&type=script&lang=js&"
export * from "./text-page.vue?vue&type=script&lang=js&"
import style0 from "./text-page.vue?vue&type=style&index=0&id=744a91a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a91a6",
  null
  
)

export default component.exports